import { Molecule } from "AppReact";
import styled from "styled-components";
import getIsMobile from "components/atoms/utils/getIsMobile";
import { Button } from "./atoms"
const isMobile = getIsMobile();

const template = styled.label``;

export default Molecule({
  template,
  type: "dropFile",
  atoms: [
    {
      component: Button,
      name: "Button",
      displayValue: ({ title }) => title ?? "Upload File",
      displayState: ({ disabled, mobileSmall, small, fontWeight }) => ({ fontWeight, small, disabled, mobileSmall }),
    },
  ],
});
